export const LANGHAM_2026_TEMPLATES = [
  'langhamNewYork2026',
  'langhamBoston2026',
  'langhamChicago2026',
  'langhamEatonDC2026',
];

export function isLangham2026Template(name) {
  return LANGHAM_2026_TEMPLATES.includes(name);
}

export function shouldSkipLangham2026Interstitial(name) {
  return name === 'langhamNewYork2026';
}
